var map = {
	"./frontend_v1/roboto-cyrillic-ext.woff2": 1047,
	"./frontend_v1/roboto-cyrillic.woff2": 3676,
	"./frontend_v1/roboto-latin-ext.woff2": 6529,
	"./frontend_v1/roboto-latin.woff2": 8327,
	"./frontend_v2/helvetica-bold.woff2": 7081,
	"./frontend_v2/helvetica.woff2": 4719,
	"./frontend_v2/inter-medium.woff2": 5808
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2437;